import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import { Button, Checkbox } from "@components/atoms";
import { TextareaField, TextField } from "@components/molecules";
import { Overlay } from "@temp/components";
import { Formik } from "formik";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import ReactSVG from "react-svg";
import contactFormIcon from "../../../images/contact-form-icon.svg";
import closeImg from "../../../images/x.svg";
import { commonMessages, validationCommonMsg } from "../../../intl";
export function Contact(_ref) {
  var overlay = _ref.overlay;
  var intl = useIntl();
  var hide = overlay.hide;

  var setAllFieldsTouched = function setAllFieldsTouched(values, setFieldTouched) {
    Object.keys(values).forEach(function (element) {
      setFieldTouched(element, true, true);
    });
  };

  var descriptionFieldMaxLength = 1200;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      accepted = _useState2[0],
      setAccepted = _useState2[1];

  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement(Formik, {
    initialValues: {
      description: "",
      email: "",
      fullName: ""
    },
    onSubmit:
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(values, _ref2) {
        var setSubmitting;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setSubmitting = _ref2.setSubmitting;
                setSubmitting(false);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }(),
    validate: function validate(values) {
      var errors = {};

      if (!values.fullName.length) {
        errors.fullName = intl.formatMessage(validationCommonMsg.required);
      }

      if (!values.email.length) {
        errors.email = intl.formatMessage(validationCommonMsg.required);
      }

      if (!values.description.length) {
        errors.description = intl.formatMessage(validationCommonMsg.required);
      }

      return errors;
    }
  }, function (_ref4) {
    var handleChange = _ref4.handleChange,
        handleSubmit = _ref4.handleSubmit,
        handleBlur = _ref4.handleBlur,
        values = _ref4.values,
        touched = _ref4.touched,
        errors = _ref4.errors,
        isSubmitting = _ref4.isSubmitting,
        setFieldTouched = _ref4.setFieldTouched;
    return React.createElement("div", {
      className: "contact-popup"
    }, React.createElement(ReactSVG, {
      path: closeImg,
      onClick: hide,
      className: "contact-popup__close"
    }), React.createElement("div", {
      className: "contact-popup__header"
    }, React.createElement("img", {
      src: contactFormIcon,
      alt: "img"
    }), React.createElement("div", {
      className: "contact-popup__header-title"
    }, intl.formatMessage(_defineProperty({
      defaultMessage: "Contact us",
      "id": "components.OverlayManager.Contact.Contact.1187718370"
    }, "id", "components.OverlayManager.Contact.Contact.1187718370")))), React.createElement("form", {
      className: "contact-popup__form",
      onSubmit: handleSubmit
    }, React.createElement("div", {
      className: "form-row"
    }, React.createElement(TextField, {
      name: "fullName",
      label: intl.formatMessage(_defineProperty({
        defaultMessage: "Your name",
        "id": "components.OverlayManager.Contact.Contact.2657164037"
      }, "id", "components.OverlayManager.Contact.Contact.2657164037")),
      value: values.fullName,
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: function onFocus() {
        return setAllFieldsTouched(values, setFieldTouched);
      },
      required: true,
      errors: touched.fullName ? [{
        message: errors.fullName
      }] : null // TODO add backend error messages
      // errors={
      //   touched.fullName && errors.fullName
      //     ? [{ message: errors.fullName }]
      //     : undefined || fieldErrors!.fullName
      // }

    })), React.createElement("div", {
      className: "form-row"
    }, React.createElement(TextField, {
      name: "email",
      label: intl.formatMessage(_defineProperty({
        defaultMessage: "Your email address",
        "id": "components.OverlayManager.Contact.Contact.1357897190"
      }, "id", "components.OverlayManager.Contact.Contact.1357897190")),
      value: values.email,
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: function onFocus() {
        return setAllFieldsTouched(values, setFieldTouched);
      },
      required: true,
      errors: touched.email ? [{
        message: errors.email
      }] : null
    })), React.createElement("div", {
      className: "form-row"
    }, React.createElement(TextareaField, {
      label: intl.formatMessage(_defineProperty({
        defaultMessage: "Your message...",
        "id": "components.OverlayManager.Contact.Contact.189418074"
      }, "id", "components.OverlayManager.Contact.Contact.189418074")),
      name: "description",
      value: values.description,
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: function onFocus() {
        return setAllFieldsTouched(values, setFieldTouched);
      },
      errors: touched.description ? [{
        message: errors.description
      }] : null,
      maxLength: descriptionFieldMaxLength
    })), React.createElement("div", {
      className: "review-popup__characters-counter"
    }, descriptionFieldMaxLength - values.description.length, intl.formatMessage(_defineProperty({
      defaultMessage: " characters left",
      "id": "components.OverlayManager.Contact.Contact.3315730334"
    }, "id", "components.OverlayManager.Contact.Contact.3315730334"))), React.createElement("div", {
      className: "form-row"
    }, React.createElement(Checkbox, {
      className: "accepted-checkbox",
      name: "accepted",
      checked: accepted,
      onChange: function onChange() {
        return setAccepted(function (v) {
          return !v;
        });
      },
      color: "primary"
    }, intl.formatMessage(commonMessages.accept), React.createElement(Link, {
      to: "#"
    }, intl.formatMessage(commonMessages.termsOfService)))), React.createElement("div", {
      className: "form-button"
    }, React.createElement(Button, {
      className: "button red",
      type: "submit",
      disabled: isSubmitting || !accepted
    }, intl.formatMessage(commonMessages.send)))));
  }));
}